import { useEffect } from 'react';
import { Dropdown, message, Button } from 'antd';
import useProjectStore from '../store/projectStore';
import useTabManagerStore from '../store/tabManagerStore';
import { createContextLogger } from '../utils/logger';

const logger = createContextLogger('ProjectDropdown');
import { PlusOutlined } from '@ant-design/icons';

const ProjectDropdown = () => {
  const { projects, activeProject, setActiveProject } = useProjectStore();
  const { clearStore } = useTabManagerStore();

  useEffect(() => {
    logger.debug('Initializing project pipelines');

    // Clear existing pipelines first
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('pipeline_')) {
        localStorage.removeItem(key);
        logger.debug('Cleared pipeline:', key);
      }
    }

    // Create placeholder pipelines with correct project IDs
    projects.forEach((project) => {
      let pipelineCount = 0;
      if (project.id === '1') pipelineCount = 3;
      if (project.id === '2') pipelineCount = 4;
      if (project.id === '3') pipelineCount = 5;

      logger.debug('Creating pipelines for project:', {
        projectId: project.id,
        projectName: project.name,
        pipelineCount,
      });

      // for (let i = 0; i < pipelineCount; i++) {
      //     const pipelineId = `pipeline_${project.id}_${i}`;
      //     const pipelineData = {
      //         id: pipelineId,
      //         name: `${project.name} Pipeline ${i + 1}`,
      //         project: project.id,
      //         description: `Pipeline ${i + 1} for ${project.name}`,
      //         nodes: [],
      //         edges: []
      //     };
      //     localStorage.setItem(pipelineId, JSON.stringify(pipelineData));
      //     logger.debug('Created pipeline:', pipelineData);
      // }
    });

    // Load pipelines for active project if one is selected
    if (activeProject) {
      logger.debug('Loading pipelines for active project:', {
        projectId: activeProject.id,
        projectName: activeProject.name,
      });
      // Pipeline loading will be handled by the store
    }
  }, [projects, activeProject]);

  const handleMenuClick = (e: any) => {
    const selectedProject = projects.find((project) => project.id === e.key);
    if (selectedProject) {
      logger.debug('Switching to project:', {
        projectId: selectedProject.id,
        projectName: selectedProject.name,
      });

      clearStore();
      setActiveProject(selectedProject.id);
      message.success(`Switched to project: ${selectedProject.name}`);
    } else {
      logger.warn('Project not found:', e.key);
    }
  };

  const menuItems = [
    {
      key: 'new',
      label: (
        <Button
          type="text"
          icon={<PlusOutlined style={{ color: '#237804' }} />}
          style={{
            width: '100%',
            textAlign: 'left',
            padding: '4px 8px',
            height: 'auto',
            color: 'rgba(0, 0, 0, 0.88)',
          }}
        >
          Create New
        </Button>
      ),
    },
    {
      type: 'divider' as const,
    },
    ...projects.map((project) => ({
      key: project.id,
      label: project.name,
    })),
  ];

  return (
    <Dropdown menu={{ items: menuItems, onClick: handleMenuClick }} trigger={['click']}>
      <Button>{activeProject ? activeProject.name : 'Select Project'}</Button>
    </Dropdown>
  );
};

export default ProjectDropdown;
